import {
  LOGIN,
  CURRENT_LOCATION,
  REFRESH_TOKEN,
  PROFILE_FETCH,
  PROFILE_SAVE,
  LOGOUT,
  RESEND_OTP,
  DRIVER_STATUS,
  PROFILE_IMAGE,
  GOOGLE_MAPS_LOADED,
  CAR_REGISTER_CHECK,
  CAR_REGISTER_CHECK_NULL,
  REFRESH_ZONE,
  LAST_BOOKING_ZONE_ID,
  EMERGENCY_DETAILS,
  GET_EMERGENCY_DETAILS,
  DELETE_EMERGENCY_DETAILS,
  FETCH_TRIPS_COUNT,
  CUSTOMER_MIGRATE,
  IMAGE_PROCESS,
  DRIVER_PROFILE_UPDATE,
  VEHICLE_LIST,
  VEHICLE_GET_DETAILS,
  VEHICLE_DETAILS_SAVE,
  VEHICLE_DETAILS_UPDATE,
  UPLOAD_DRIVER_IMAGES,
  FETCH_DRIVER_DETAILS,
  DRIVER_FILES,
  UPLOAD_VEHICLE_FILES,
  VEHICLE_FILES,
  CLEAR_VEHICLE_DETAILS,
  SHARE_VEHICLE,
  SHARE_NOTIFICATIONS,
  ABORT_SHARE,
  DRIVER_APPROVAL,
  VEHICLE_APPROVAL,
  BUMP_SHARE_UNREAD,
  CLEAR_SHARE_UNREAD,
  CHECK_DRIVER_VALIDATION,
  SUBSCRIBE_VEHICLE,
  UNSUBSCRIBE_VEHICLE,
  TERMINATE_VEHICLE,
} from "App/store/constants";

const initialState = {
  refreshTokenLoaded: null,
  vehicle_list: null,
  vehilce_details: {},
  driverProfileDetails: <any>null,
  vehilce_profile_details: <any>null,
  share_notications:[],
  // Count of pending invites *received* by the current user. Drives
  // the header menu badge. Recomputed on every shareNotifications
  // fetch (authoritative) and bumped by the socket listener so the
  // badge updates without a manual pull.
  shareUnreadCount: 0,
  driver_check:<any>null,
  driverStatus: false,
  loggedIn: false,
  loginVerifyStep: false,
  loginError: null,
  currentLocation: null,
  profileData: null,
  resendOTPCount: 0,
  user: <any>null,
  token: null,
  loading: false,
  driverDetails: <any>null,
  sentRequest: null,
  driverSentRequest:null,
  vehicleSentRequest:null,
  lastFileUploaded: null,
  googleMapLoaded: null,
  vehicleCheckDetails: null,
  emergencyDetails: [],
  zone: <any>null,
  removeDetails: null,
  booking_id: null,
  countryCode: localStorage.getItem("countryCode") || null,
  tripsCount: null,
  migrated: null,
  errorEmergencyMsg: null,
  successEmergencyMsg: null
};

const storeSessionData = async (response: any) => {
  localStorage.setItem("refreshToken", response.refreshToken);
  localStorage.setItem("countryCode", response.data.user.country_code);
  localStorage.setItem("user", JSON.stringify(response.data.user));
  localStorage.setItem("userToken", response.data.access_token);
};

const clearSessionData = async () => {
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
  localStorage.removeItem("userToken");
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case LOGIN.PENDING:
      return { ...state, errors: null, loginError: null, user: null, token: null, loggedIn: false, loading: true };
    case LOGIN.SUCCESS:
      const response = action.payload;
      if (response.status === 'success') {
        storeSessionData(response);
        let booking_id = null;
        if (response?.booking_id)
          booking_id = response?.booking_id;

        return {
          ...state,
          user: response.data.user,
          token: response.data.access_token,
          loggedIn: true,
          booking_id: booking_id,
          loading: false,
        };
      } else {
        return { ...state, loginError: response.msg, loading: false };
      }
    case LOGIN.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case CURRENT_LOCATION:
      return { ...state, currentLocation: action.payload };

    case GOOGLE_MAPS_LOADED:
      return { ...state, googleMapLoaded: action.payload };

    case REFRESH_ZONE.PENDING:
      return { ...state, errors: null, loading: true };
    case REFRESH_ZONE.SUCCESS:
      return { ...state, zone: action.payload.data, loading: false };
    case REFRESH_ZONE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case REFRESH_TOKEN.PENDING:
      return { ...state, errors: null, refreshTokenLoaded: false };
    case REFRESH_TOKEN.SUCCESS:
      const res = action.payload;
      if (res.status === "success") {
        storeSessionData(res);
        return {
          ...state,
          user: res.data.user,
          token: res.data.access_token,
          loggedIn: true,
          refreshTokenLoaded: true,
        };
      } else {
        return state;
      }
    case REFRESH_TOKEN.FAILURE:
      return { ...state, errors: action.payload, refreshTokenLoaded: true };

    case PROFILE_FETCH.PENDING:
      return { ...state, errors: null, loading: true };
    case PROFILE_FETCH.SUCCESS:
      return { ...state, profileData: action.payload.data, loading: false };
    case PROFILE_FETCH.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case PROFILE_IMAGE.PENDING:
      return { ...state, errors: null, loading: true };
    case PROFILE_IMAGE.SUCCESS:
      const temp: any = { ...state.user };
      temp.img = action.payload.file;
      return { ...state, user: temp, loading: false };
    case PROFILE_IMAGE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case RESEND_OTP.PENDING:
      return { ...state, loading: true };
    case RESEND_OTP.SUCCESS:
      return {
        ...state,
        resendOTPCount: state.resendOTPCount + 1,
        loading: false,
      };
    case RESEND_OTP.FAILURE:
      return { ...state, loading: false };
    case DRIVER_STATUS.PENDING:
      return { ...state, errors: null, loading: true };
    case DRIVER_STATUS.SUCCESS:
      return { ...state, driverStatus: action.payload, loading: false };
    case DRIVER_STATUS.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case LAST_BOOKING_ZONE_ID.PENDING:
      return { ...state, errors: null, loading: true };
    case LAST_BOOKING_ZONE_ID.SUCCESS:
      let tempUser = { ...state.user };
      if (action.payload?.zone_id !== 0) {
        tempUser.details = { zone_id: action.payload.zone_id };
      }
      return { ...state, user: tempUser, loading: false };
    case LAST_BOOKING_ZONE_ID.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case CAR_REGISTER_CHECK.PENDING:
      return { ...state, errors: null, loading: true };
    case CAR_REGISTER_CHECK.SUCCESS:
      return {
        ...state,
        vehicleCheckDetails: action.payload.data,
        loading: false,
      };
    case CAR_REGISTER_CHECK.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case CAR_REGISTER_CHECK_NULL:
      return { ...state, vehicleCheckDetails: null };

    case CUSTOMER_MIGRATE.PENDING:
      return { ...state, loading: true, migrated: false, errors: null };
    case CUSTOMER_MIGRATE.SUCCESS:
      return { ...state, loading: false, migrated: true };
    case CUSTOMER_MIGRATE.FAILURE:
      return { ...state, loading: true, migrated: false, errors: action.payload };

    case EMERGENCY_DETAILS.PENDING:
      return { ...state, successEmergencyMsg: null, errorEmergencyMsg: null, loading: true };
    case EMERGENCY_DETAILS.SUCCESS:
      return { ...state, successEmergencyMsg: action.payload, loading: false };
    case EMERGENCY_DETAILS.FAILURE:
      return { ...state, errorEmergencyMsg: action.payload, loading: false };

    case GET_EMERGENCY_DETAILS.PENDING:
      return { ...state, errors: null, successEmergencyMsg: null, errorEmergencyMsg: null, loading: true };
    case GET_EMERGENCY_DETAILS.SUCCESS:
      return { ...state, emergencyDetails: action.payload.data, loading: false };
    case GET_EMERGENCY_DETAILS.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case DELETE_EMERGENCY_DETAILS.PENDING:
      return { ...state, errors: null, successEmergencyMsg: null, loading: true };
    case DELETE_EMERGENCY_DETAILS.SUCCESS:
      return { ...state, removeDetails: action.payload.data, loading: false };
    case DELETE_EMERGENCY_DETAILS.FAILURE:
      return { ...state, errors: action.payload, loading: false };
    case FETCH_TRIPS_COUNT.PENDING:
      return { ...state, errors: null, loading: true };
    case FETCH_TRIPS_COUNT.SUCCESS:
      return { ...state, tripsCount: action.payload.data, loading: false };
    case FETCH_TRIPS_COUNT.FAILURE:
      return { ...state, errors: action.payload, loading: false };
    case PROFILE_SAVE.PENDING:
      return { ...state, errors: null, loading: true };
    case PROFILE_SAVE.SUCCESS:
      return { ...state, loading: false };
    case PROFILE_SAVE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case LOGOUT.PENDING:
      return { ...state, errors: null, loading: true };
    case LOGOUT.SUCCESS:
      clearSessionData();
      return { ...state, user: null, loggedIn: false, loginVerifyStep: null, loading: false };
    case LOGOUT.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case IMAGE_PROCESS.PENDING:
      return { ...state, errors: null, loading: true };
    case IMAGE_PROCESS.SUCCESS:
      return { ...state, imageprocess: action.payload.data, loading: false };
    case IMAGE_PROCESS.FAILURE:
      return { ...state, errors: action.payload, loading: false };
    //***************DRIVER SAVE ****************************************************************/

    case DRIVER_PROFILE_UPDATE.PENDING:
      return { ...state, errors: null, loading: true };
    case DRIVER_PROFILE_UPDATE.SUCCESS:
      return { ...state, driverProfileDetails: action.payload.data, loading: false };
    case DRIVER_PROFILE_UPDATE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case UPLOAD_DRIVER_IMAGES.PENDING:
      return { ...state, errors: null, loading: true };
    case UPLOAD_DRIVER_IMAGES.SUCCESS:
      const updatedDriverDetail: any = { ...state.driverProfileDetails };
      updatedDriverDetail[action.payload.field] = action.payload.file;
      return { ...state, driverProfileDetails: updatedDriverDetail, loading: false };
    case UPLOAD_DRIVER_IMAGES.FAILURE:
      return { ...state, errors: action.payload, loading: false };


    case FETCH_DRIVER_DETAILS.PENDING:
      return { ...state, errors: null, loading: true };
    case FETCH_DRIVER_DETAILS.SUCCESS:
      return { ...state, driverProfileDetails: action.payload.data, loading: false };
    case FETCH_DRIVER_DETAILS.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case DRIVER_FILES.PENDING:
      return { ...state, errors: null, loading: true };
    case DRIVER_FILES.SUCCESS:
      const driverDetls: any = { ...state.driverProfileDetails };
      driverDetls[action.payload.field] = action.payload.file;
      return { ...state, driverProfileDetails: driverDetls, loading: false };
    case DRIVER_FILES.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case DRIVER_APPROVAL.PENDING:
      return { ...state, errors: null, loading: true };
    case DRIVER_APPROVAL.SUCCESS:
      return { ...state, driverSentRequest: action.payload.data, loading: false };
    case DRIVER_APPROVAL.FAILURE:
      return { ...state, errors: action.payload, loading: false };
    //********************** VEHICLE ***************** *********************************************/
    case VEHICLE_LIST.PENDING:
      return { ...state, errors: null, loading: true };
    case VEHICLE_LIST.SUCCESS:
      return { ...state, vehicle_list: action.payload.data, loading: false };
    case VEHICLE_LIST.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case VEHICLE_GET_DETAILS.PENDING:
      return { ...state, errors: null, loading: true };
    case VEHICLE_GET_DETAILS.SUCCESS:
      return { ...state, vehilce_details: action.payload.msg, loading: false };
    case VEHICLE_GET_DETAILS.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case VEHICLE_DETAILS_SAVE.PENDING:
      return { ...state, errors: null, loading: true };
    case VEHICLE_DETAILS_SAVE.SUCCESS:
      return { ...state, vehilce_profile_details: action.payload.data, vehilce_details: action.payload.data, loading: false };
    case VEHICLE_DETAILS_SAVE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case VEHICLE_DETAILS_UPDATE.PENDING:
      return { ...state, errors: null, loading: true };
    case VEHICLE_DETAILS_UPDATE.SUCCESS:
      return { ...state, vehilce_profile_details: action.payload.data,  vehilce_details: {...state.vehilce_details,...action.payload.data} ,loading: false };
    case VEHICLE_DETAILS_UPDATE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case UPLOAD_VEHICLE_FILES.PENDING:
      return { ...state, errors: null, loading: true };
    case UPLOAD_VEHICLE_FILES.SUCCESS:
      const updatedDriverDtl: any = { ...state.vehilce_profile_details };
      updatedDriverDtl[action.payload.field] = action.payload.file;
      return { ...state, vehilce_profile_details: updatedDriverDtl, loading: false };
    case UPLOAD_VEHICLE_FILES.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case CLEAR_VEHICLE_DETAILS:
      return {
        ...state,
        vehilce_details: null,
      };

    case VEHICLE_FILES.PENDING:
      return { ...state, errors: null, loading: true };
    case VEHICLE_FILES.SUCCESS:
      const driverD: any = { ...state.vehilce_profile_details };
      driverDetls[action.payload.field] = action.payload.file;
      return { ...state, vehilce_profile_details: driverD, loading: false };
    case VEHICLE_FILES.FAILURE:
      return { ...state, errors: action.payload, loading: false };

// QA recheck (W1) — driver-check verify gets its own action type so
// the share-create response no longer overwrites driver_check.
    case CHECK_DRIVER_VALIDATION.PENDING:
      return { ...state, errors: null, loading: true };
    case CHECK_DRIVER_VALIDATION.SUCCESS:
      return { ...state, driver_check: action.payload, loading: false };
    case CHECK_DRIVER_VALIDATION.FAILURE:
      return { ...state, errors: action.payload, loading: false };

//Vehicle Share — share-create response. We deliberately don't write
// driver_check here any more (W1); the slice key belongs to the
// verify call. Keep the loading/errors flips so existing UI that
// depends on `loading` still works.
    case SHARE_VEHICLE.PENDING:
      return { ...state, errors: null, loading: true };
    case SHARE_VEHICLE.SUCCESS:
      return { ...state, loading: false };
    case SHARE_VEHICLE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

//Vehicle notifications
    case SHARE_NOTIFICATIONS.PENDING:
      // QA recheck (W5) — don't wipe the list on PENDING. The previous
      // behaviour cleared cards mid-refresh, removing in-flight rows
      // that had a `pendingId` accept/reject in motion.
      return { ...state, errors: null, loading: true };
    case SHARE_NOTIFICATIONS.SUCCESS: {
      const list = action.payload?.data || [];
      // Authoritative unread count = pending invites *received* by us.
      // Overwrites any optimistic socket-driven bumps since the fetch
      // is the source of truth.
      const shareUnreadCount = list.filter(
        (n: any) => n?.type === 'received' && n?.status === 'pending',
      ).length;
      return { ...state, share_notications: list, shareUnreadCount, loading: false };
    }
    case SHARE_NOTIFICATIONS.FAILURE:
      // Don't wipe on failure either — the existing list is the best
      // we can offer the user; the toast (errorMsg=true) tells them
      // the refetch failed.
      return { ...state, errors: action.payload, loading: false };

    // Optimistic +1 from the `vehicleShare` socket event when a new
    // invite arrives. Followed up by a fetch that overwrites with
    // the authoritative count.
    case BUMP_SHARE_UNREAD:
      return { ...state, shareUnreadCount: (state.shareUnreadCount || 0) + 1 };

    // Cleared when the user opens the Share Notifications screen.
    case CLEAR_SHARE_UNREAD:
      return { ...state, shareUnreadCount: 0 };

    case ABORT_SHARE.PENDING:
      return { ...state, errors: null, loading: true };
    case ABORT_SHARE.SUCCESS:
      return { ...state, loading: false };
    case ABORT_SHARE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

// QA recheck (W2) — subscribe/unsubscribe/terminate previously aliased
// ABORT_SHARE; that meant the response payload was silently dropped
// and only `loading` flipped. Each gets its own case now. The slice
// doesn't need to mirror the response body — child components rely
// on a follow-up `vehiclesList()` fetch that they now await — so
// we only update the flags.
    case SUBSCRIBE_VEHICLE.PENDING:
    case UNSUBSCRIBE_VEHICLE.PENDING:
    case TERMINATE_VEHICLE.PENDING:
      return { ...state, errors: null, loading: true };
    case SUBSCRIBE_VEHICLE.SUCCESS:
    case UNSUBSCRIBE_VEHICLE.SUCCESS:
    case TERMINATE_VEHICLE.SUCCESS:
      return { ...state, loading: false };
    case SUBSCRIBE_VEHICLE.FAILURE:
    case UNSUBSCRIBE_VEHICLE.FAILURE:
    case TERMINATE_VEHICLE.FAILURE:
      return { ...state, errors: action.payload, loading: false };

    case VEHICLE_APPROVAL.PENDING:
      return { ...state, errors: null, loading: true };
    case VEHICLE_APPROVAL.SUCCESS:
      return { ...state, vehicleSentRequest: action.payload.data, loading: false };
    case VEHICLE_APPROVAL.FAILURE:
      return { ...state, errors: action.payload, loading: false };
      
    default:
      return state;
  }
};

export default reducer;
